<!--  厦门国际银行-企业微信拉新抽奖活动 -->
<template>
  <div
    :class="{
      'xiame-bank-new-guests-have-gifts-index-page': true,
    }"
  >
    <!-- 骨架屏 -->
    <div v-if="imgLoading" style="padding-top: 250px">
      <van-skeleton title :row="5" />
      <van-skeleton title :row="5" style="margin-top: 30px" />
    </div>
    <div v-else>
      <div class="rule-btn-box">
        <img
          class="icon"
          :src="require(`@/assets/imgs/xiameBankNewGuestsHaveGifts/rule.png`)"
          alt=""
          @click="toRule"
        />
      </div>
      <div class="seat"></div>
      <div class="lucky-content" v-show="prizes.length">
        <LuckyWheel
          ref="myLucky"
          width="7.00rem"
          height="7.00rem"
          :prizes="prizes"
          :blocks="blocks"
          :buttons="buttons"
          @start="startCallback"
          @end="endCallback"
          :default-config="defaultConfig"
        />
        <div class="click-btn" @click="startCallback"></div>
        <!-- <div class="info">陈**抽中888元微信立减金</div> -->

        <!-- <van-swipe
          class="info"
          style="height: 40px"
          vertical
          :autoplay="3000"
          :show-indicators="false"
          :loop="true"
        >
          <van-swipe-item v-for="item in prizesInfo" :key="item">{{
            item
          }}</van-swipe-item>
        </van-swipe> -->
      </div>
      <div class="btn-box">
        <img
          class="award"
          :src="require(`@/assets/imgs/xiameBankNewGuestsHaveGifts/award.png`)"
          alt=""
          @click="toPrizes"
        />
        <img
          class="btn"
          :src="require(`@/assets/imgs/xiameBankNewGuestsHaveGifts/btn1.png`)"
          alt=""
          @click="startCallback"
        />
        <img
          class="hand animate__animated animate__heartBeat animate__infinite"
          :src="require(`@/assets/imgs/xiameBankNewGuestsHaveGifts/hand.png`)"
          alt=""
          @click="startCallback"
        />
      </div>
    </div>

    <!-- 中将弹窗 -->
    <WinningPopup ref="winningPopupRef" />
  </div>
</template>
<script>
import { login, getLotteryStauts, check, lottery } from '@/api/xibWorkWeChatLottery.js'
import WinningPopup from './components/WinningPopup.vue'
import { Toast } from 'vant'
import { wxApiEmpower, isWechat } from '@/utils/common'
// import { nextTick } from 'vue'
export default {
  components: {
    WinningPopup,
  },
  data() {
    return {
      title: '厦门国际银行',
      defaultConfig: {
        speed: 5,
      },
      blocks: [],
      prizesData: [
        // { text: '888' },
        // { text: '8.88' },
        // { text: '18.8' },
        // { text: '1.58' },
        // { text: '0' },
        // { text: '1.58' },
        // { text: '18.8' },
        // { text: '8.88' },
        // 需求奖品变更T1006529
        { text: '88' },
        { text: '8.88' },
        { text: '5.88' },
        { text: '1.88' },
        { text: '88' },
        { text: '1.88' },
        { text: '5.88' },
        { text: '8.88' }
      ],
      prizes: [
      ],
      buttons: [
        {
          radius: '40%',
          pointer: true,
          imgs: [
            {
              src: require(`@/assets/imgs/xiameBankNewGuestsHaveGifts/btn3.png`),
              top: '-65px',
              width: '90px',
              height: '110px',
            }
          ],
        }
      ],
      lotteryDisable: false, // 抽奖中
      userInfo: {
        lotteryStatus: undefined, // 抽奖次数，0表示没抽过，可以抽
        check: undefined, // 是否符合资格 1有资格 toto,1的类型是数组还是字符
        loginError: undefined, // 登录错误信息
      },
      activityInfo: {
        hasActivityEnded: false, // 活动是否结束
      },
      imgLoading: true,
      prizesInfo: [
        '陈**抽中8.88元微信立减金',
        '叶**抽中1.88元微信立减金',
        '林*抽中5.88元微信立减金',
        '卓**抽中88元微信立减金',
        '王*抽中1.88元微信立减金',
      ]
    }
  },
  mounted() {
    this.preFetchImg().then(() => {
      this.initPrizes()
      this.imgLoading = false
      this.startTurn()
    })
    this.setActivityInfo()
    if (sessionStorage.getItem('xibWorkWeChatLotteryToken')) {
      this.getUserInfo()
    } else {
      this.login()
    }

    this.hideShare()
  },
  methods: {
    login() {
      login({
        code: sessionStorage.getItem('ydsh-ph-h5-bankv3-wxcode'),
        custNo: this.$route.query.custNo
      }).then(res => {
        // console.log(res, 'then====');
        if (res.code === 0) {
          sessionStorage.setItem('xibWorkWeChatLotteryToken', res.data.token)
          this.getUserInfo()
        } else {
          if (res.message === '获取openid错误!') {
            Toast(res.message)
            this.$store.commit('signOut')
            location.reload()
          } else {
            this.userInfo.loginError = res.message
            this.exceptionPrompt()
          }
        }
      }).catch(res => {
        // console.log(res, 'catch====');

      })
    },
    getUserInfo() {
      check({}).then(res => {
        if (res.code === 0) {
          this.userInfo.check = res.data
          this.exceptionPrompt()
          getLotteryStauts({}).then(res => {
            if (res.code === 0) {
              this.userInfo.lotteryStatus = res.data
              // 如果没有异常弹窗，且可抽奖的话提示有抽奖次数(去掉)
              // if (!this.$refs.winningPopupRef.show) {
              //   if (this.userInfo.lotteryStatus === 0) {
              //     this.openMessage(1)
              //   }
              // }
            }
          })
        }
      })

    },
    // 点击抽奖按钮会触发star回调
    startCallback(value) {
      if (this.lotteryDisable === true) {
        console.log('请不要频繁点击');
        return
      }
      if (!this.exceptionPrompt()) return

      this.lotteryDisable = true
      this.stopTurn()
      this.$refs.myLucky.play()
      lottery({}).then(res => {

        // let res = { "code": 0, "data": { "description": "测试券,请不要核销", "prizeId": 631, "prizeName": "1.58元", "status": 1 }, "message": "操作成功" }
        // let res = { "code": 0, "data": { "prizeId": 632, "prizeName": "888元", "recordList": [{ "description": "测试券,请不要核销", "status": 1, "stockName": "厦门国际银行test1" }, { "description": "测试清楚,请不要核销", "status": 1, "stockName": "厦门国际银行test2" }] }, "message": "操作成功" }



        let { prizeName, status, recordList } = res.data
        // 奖品是券包的情况下，status根据券包的有方法成功的券状态展示
        if (recordList) {
          let one = recordList.find(i => i.status === 1)
          if (one) {
            status = 1
          }
        }
        if (status === 1) {
          if (prizeName === '谢谢惠顾') {
            let index = this.prizesData.findIndex(i => {
              return i.text === '0'
            })
            setTimeout(() => {
              this.$refs.myLucky.stop(index)
              this.openMessage(3)
              this.lotteryDisable = false
            }, 3000)
          } else {
            let str = prizeName.replace(/[^\d.]/g, "")
            let index = this.prizesData.findIndex(i => {
              return i.text === str
            })
            if (index === -1) {
              this.$toast('奖品名称配置错误，请运营重新配置')
            }
            // console.log('匹配奖品名称金额', str, index);
            setTimeout(() => {
              this.$refs.myLucky.stop(index)
            }, 3000)
          }

        } else { // 发券失败
          this.$refs.myLucky.stop(-1)
          this.openMessage(999, res.message || '发券失败')
          this.lotteryDisable = false
        }

      }).catch((res) => {
        if (res.message === '很遗憾，您没有中奖！') {
          this.openMessage(3)
        } else {
          this.openMessage(999, res.message)
        }
        this.startTurn()
        setTimeout(() => {
          this.lotteryDisable = false
        }, 2000)
      })
    },
    // 异常弹窗
    exceptionPrompt() {
      if (this.userInfo.loginError) {
        this.openMessage(999, this.userInfo.loginError)
        return false
      }
      if (this.activityInfo.hasActivityEnded) {
        this.openMessage(999, '活动已结束')
        return false
      }
      if (('' + this.userInfo.check) !== '1') {
        this.openMessage(0)
        return false
      }
      // if (this.userInfo.lotteryStatus !== 0) {
      //   this.openMessage(999, '')
      //   return false
      // }
      return true
    },
    // 抽奖结束会触发end回调
    endCallback(prize) {
      // console.log(prize, 'prize==');
      if (prize.text && prize.text !== '0') {
        this.openMessage(2, prize.text) // 中奖
      }
      this.lotteryDisable = false
    },
    // 消息弹窗
    openMessage(type, message) {
      this.$refs.winningPopupRef.open(type, message)
    },
    // 转盘默认缓慢旋转
    startTurn(speed = 0.2) {
      this.defaultConfig.speed = speed
      setTimeout(() => {
        this.$refs.myLucky.init()
        this.$refs.myLucky.play()
      }, 1000)

    },
    // 转盘停止，旋转速度正常
    stopTurn() {
      this.defaultConfig.speed = 3
      this.$refs.myLucky.stop(-1)
    },

    toRule() {
      this.$router.push({ name: 'XiameBankNewGuestsHaveGiftsRule' })
    },
    toPrizes() {
      if (this.userInfo.loginError) {
        this.openMessage(999, this.userInfo.loginError)
        return false
      }
      this.$router.push({ name: 'XiameBankNewGuestsHaveGiftsRecord' })
    },
    // 活动状态，是否结束
    setActivityInfo() {
      // :即日起-2025年12月31日，超过活动时间则提示语提示“活动已结束”
      // const targetDate = new Date("2025-12-31");
      // T1006529活动延期
      const targetDate = new Date("2026-12-31T23:59:59+08:00")
      const currentDate = new Date();
      this.activityInfo.hasActivityEnded = currentDate > targetDate
    },
    // 禁止分享
    hideShare() {
      if (!isWechat()) return
      wxApiEmpower().then(() => {
        // eslint-disable-next-line no-undef
        wx.hideAllNonBaseMenuItem({
          success: function () { },
          fail: function (res) {
            console.log(res, '禁止分享-设置失败')
          }
        })
      })
    },
    // 设置奖品样式
    initPrizes() {
      this.prizes = this.prizesData.map((item, index) => {
        let obj = {
          background: index % 2 === 0 ? '#E2F6FF' : '#ffffff',
          fonts: [],
          imgs: [
            {
              src: require(`@/assets/imgs/xiameBankNewGuestsHaveGifts/${item.text}.png`),
              top: '15px',
              width: '35px',
              height: '50px',
            }
          ],
          text: item.text,
        }
        return obj
      })
    },
    // 页面图片预先加载
    preFetchImg() {
      return new Promise((resolve, reject) => {
        let imgs = [
          require("@/assets/imgs/xiameBankNewGuestsHaveGifts/0.png"),
          require("@/assets/imgs/xiameBankNewGuestsHaveGifts/1.88.png"),
          require("@/assets/imgs/xiameBankNewGuestsHaveGifts/5.88.png"),
          require("@/assets/imgs/xiameBankNewGuestsHaveGifts/8.88.png"),
          require("@/assets/imgs/xiameBankNewGuestsHaveGifts/88.png"),
          require("@/assets/imgs/xiameBankNewGuestsHaveGifts/bg2.png"),
          require("@/assets/imgs/xiameBankNewGuestsHaveGifts/bg1.png"),
          require("@/assets/imgs/xiameBankNewGuestsHaveGifts/pbg.png"),
          require("@/assets/imgs/xiameBankNewGuestsHaveGifts/btn.png"),

        ]
        let sum = imgs.length
        let num = 0
        for (let img of imgs) {
          let image = new Image()
          image.src = img
          image.onload = () => {
            // 图片加载完整
            num++
            if (sum === num) {
              resolve()
            }
          }
        }
      })
    },

  },
}
</script>
<style lang="less" scoped>
.xiame-bank-new-guests-have-gifts-index-page {
  background: url("../../../assets/imgs/xiameBankNewGuestsHaveGifts/bg1.png")
    no-repeat #80befa;
  background-size: 100% auto;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  // overflow: auto;
  .rule-btn-box {
    font-size: 12px;
    color: #111113;
    position: fixed;
    right: -2px;
    top: 80px;
    .icon {
      width: 27px;
    }
  }
  .seat {
    width: 100%;
    height: 250px;
  }
  .lucky-content {
    margin: auto;
    padding: 30px 0 0px 29px;
    width: 320px;
    height: 460px;
    box-sizing: border-box;
    background: url("../../../assets/imgs/xiameBankNewGuestsHaveGifts/bg2.png")
      no-repeat;
    background-size: 100% auto;
    position: relative;
    .info {
      position: absolute;
      top: 72%;
      left: 14%;
      padding-top: 18px;
      width: 230px;
      font-size: 13px;
      color: #ffffff;
      text-align: center;
      // background: #111113;
    }
    .click-btn {
      position: absolute;
      top: 25%;
      left: 39%;
      z-index: 10px;
      width: 80px;
      height: 80px;
      // background: #ff6f62;
    }
  }
  .btn-box {
    text-align: center;
    height: 100px;
    position: relative;
    .btn {
      margin: 0 auto 10px auto;
      width: 60%;
    }
    .award {
      position: absolute;
      left: 5px;
      top: 0px;
      z-index: 1;
      width: 72px;
    }
    .hand {
      position: absolute;
      right: 60px;
      top: 40px;
      z-index: 1;
      width: 40px;
    }
  }
}
</style>
